import { InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface PhoneNumberMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const PhoneNumberMask = forwardRef<HTMLInputElement, PhoneNumberMaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(000) 000-0000"
      unmask
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => {
        onChange({ target: { name: props.name, value } });
      }}
      overwrite
    />
  );
});

export function PhoneNumberField(props: TextFieldProps) {
  return (
    <TextField
      {...props}
      InputProps={{
        startAdornment: <InputAdornment position="start">+1</InputAdornment>,
        // FIXME: Automatically disabled during ESLint config update
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inputComponent: PhoneNumberMask as any,
      }}
      placeholder="(XXX) XXX-XXXX"
    />
  );
}
